import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { cardsStore } from '../../store/cardsStore';
import { MAX_CARDS_COUNT } from '../../enums/cardStatus';

export const GameCardHolderContainer = observer(({ innerComp: InnerComp }) => {
  const { cuttingCardPlace, openedCardsCount, selectedCardBackSideType, isCuttingCardOpen } =
    cardsStore;

  const cuttingCardPosition = useMemo(() => {
    return ((cuttingCardPlace * 100) / (MAX_CARDS_COUNT - openedCardsCount)) * 0.2;
    // eslint-disable-next-line
  }, [cuttingCardPlace]);

  const calculateCardGroupWidth = useCallback(
    (cardImageMinWidth, cardImageMaxWidth) => {
      return (
        cardImageMinWidth +
        ((MAX_CARDS_COUNT - openedCardsCount) * (cardImageMaxWidth - cardImageMinWidth)) /
          MAX_CARDS_COUNT
      );
    },
    [openedCardsCount]
  );

  return (
    <InnerComp
      cardCut='card-cut'
      cardBack={selectedCardBackSideType}
      cuttingCardPlace={cuttingCardPlace}
      calculateCardGroupWidth={calculateCardGroupWidth}
      cuttingCardPosition={cuttingCardPosition}
      isCuttingCardOpen={isCuttingCardOpen}
    />
  );
});
